export const getProductShelfLifeTimeFormat = (value: number): { divisible: number; format: string } => {
  if (value % 365 === 0) {
    return { divisible: 365, format: "Years" }
  } else if (value % 30 === 0) {
    return { divisible: 30, format: "Months" }
  } else if (value % 7 === 0) {
    return { divisible: 7, format: "Weeks" }
  } else {
    return { divisible: 1, format: "Days" }
  }
}
